import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "section" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("h1", { class: "title" }, "Incentive Programs"),
  /*#__PURE__*/_createVNode("p", { class: "subtitle" }, "Add or modify Incentive Programs")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_4 = { class: "container" }
const _hoisted_5 = {
  key: 0,
  class: "grid-loading-spinner"
}
const _hoisted_6 = { class: "spinner-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IncentiveProgramsGrid = _resolveComponent("IncentiveProgramsGrid")
  const _component_loadingSpinner = _resolveComponent("loadingSpinner")

  return (_openBlock(), _createBlock("main", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_IncentiveProgramsGrid, {
        programs: _ctx.programs,
        areExpiredIncluded: _ctx.areExpiredIncluded,
        "onUpdate:areExpiredIncluded": _cache[1] || (_cache[1] = ($event: any) => (_ctx.areExpiredIncluded = $event)),
        onLoading: _cache[2] || (_cache[2] = ($event: any) => (_ctx.areProgramsLoading = $event)),
        onSave: _cache[3] || (_cache[3] = ($event: any) => (_ctx.save($event)))
      }, null, 8, ["programs", "areExpiredIncluded"]),
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_loadingSpinner)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}